import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './aboutusSec.module.css';
import {
    teamImg1,
    teamImg2,
    teamImg3,
    teamImg4,
    teamImg5,
    teamImg6,
    teamImg7,
    teamImg8,
} from '../../../assets';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOurTeamData } from '../../slice/teamSlice';
import { IMAGE_URL } from '../../helpers/api_helper';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';
import { Swiper, SwiperSlide } from 'swiper/react';

import { FreeMode, Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';
import { abtProg, contCre, influnceSlide1, influnceSlide2, influnceSlide3, influnceSlide4, leftArrow, rgtArrow } from '../../../assets'
// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const restructureData = (data) => {
    const groupedData = [];
    for (let i = 0; i < data.length; i += 2) {
      groupedData.push(data.slice(i, i + 2));
    }
    return groupedData;
  };

const AboutTeam = ({ teamData }) => {

    const mergeData = restructureData(teamData);

    /* const dispatch = useDispatch();
    const { data: teamData, loading, error } = useSelector((state) => state.team);

    useEffect(() => {
        dispatch(fetchOurTeamData());
    }, [dispatch]);

    useEffect(() => {
        console.log('team Data : ', teamData);
    }, [teamData]);
 */
    const { ref: abtBTRef, inView: abtBTInView, textAnimation } = useTextAnimation();
    const sectionRef = useRef(null);
    const swiperRef = useRef(null);

    const { t, i18n } = useTranslation();

    /* useEffect(() => {
        if (teamData.length > 0) {
            const path = document.querySelector(`.${styles.tLine} path`);
            const pathLength = path.getTotalLength();
            gsap.fromTo(
                path,
                { strokeDasharray: pathLength, strokeDashoffset: pathLength },
                {
                    strokeDashoffset: 0,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: path,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: .5,
                        markers: false,
                    },
                }
            );
        }
    }, []); */

    useEffect(() => {
            if (mergeData && mergeData.length > 0) {
                const path = document?.querySelector(`.${styles?.tLine} path`);
                const pathLength = path?.getTotalLength();
                gsap?.fromTo(
                    path,
                    { strokeDasharray: pathLength, strokeDashoffset: pathLength },
                    {
                        strokeDashoffset: 0,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: path,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: .5,
                            markers: false,
                        },
                    }
                );
            }
        }, []);

    return (
        <>
         
        <div className={styles._team} ref={sectionRef}>
            {/* Meet the Megaminds */}
            <div className={styles._team_title}>
                <motion.h3 ref={abtBTRef}
                    initial="hidden"
                    animate={abtBTInView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}>
                    {t('aboutUsMeet')}<span>{t('aboutUsTeam')}</span>
                </motion.h3>
            </div>


            <span className={styles.tLine}>
                {/* <svg
                    version="1.1"
                    width='705'
                    height='1021'
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 705.4 1322.2"
                    style={{ enableBackground: 'new 0 0 705.4 1322.2' }}
                    preserveAspectRatio="xMidYMax meet"
                >
                    <defs>
                        <linearGradient
                            id="SVGID_1_"
                            gradientUnits="userSpaceOnUse"
                            x1="-114.5516"
                            y1="908.4811"
                            x2="828.7083"
                            y2="399.9666"
                        >
                            <stop offset="0" style={{ stopColor: '#E53E6A' }} />
                            <stop offset="1" style={{ stopColor: '#5A71F2' }} />
                        </linearGradient>
                    </defs>
                    <path
                        className="st0"
                        d="M72.4,1223.7c0,0-167.7-884,576.8-1125.1"
                        fill="none"
                        stroke="url(#SVGID_1_)"
                        strokeWidth="30"
                        strokeLinecap="round"
                        strokeMiterlimit="10"
                    />
                </svg> */}
                {/* <svg
                    version="1.1"
                    width="260"
                    height="1292"
                    viewBox="0 0 260 1292"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ enableBackground: 'new 0 0 705.4 1322.2' }}
                    preserveAspectRatio="xMidYMax meet"
                >
                    <defs>
                        <linearGradient
                            id="paint0_linear_3467_263"
                            x1="184"
                            y1="14"
                            x2="184"
                            y2="1295"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5A71F2" />
                            <stop offset="1" stop-color="#DD043D" />
                        </linearGradient>
                    </defs>
                    <path d="M247 12.5C-1.00003 305.5 13 663 13 663C24.9999 912 117.5 1070 247 1279" stroke="url(#paint0_linear_3467_263)"
                        stroke-width="30"
                        stroke-miterlimit="10"
                        stroke-linecap="round" />
                </svg> */}
                <svg width="271" height="1310" viewBox="0 0 271 1310" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M244 17C70.6667 227.667 -170 777.8 254 1293" stroke="url(#paint0_linear_341_2440)" stroke-width="33" stroke-linecap="round" />
                    <defs>
                        <linearGradient id="paint0_linear_341_2440" x1="135.606" y1="17" x2="135.606" y2="1293" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#606EEC" />
                            <stop offset="1" stop-color="#DD043D" />
                        </linearGradient>
                    </defs>
                </svg>

            </span>
          

           
        </div>

         {/* Slider New */}
         <div className={styles.InfluencerHighlights_abtprogram}>
                                    <div className={styles.InfluencerHighlights_abtprogramInner}>
                                        <Swiper
                                            className={styles.InfluencerHighlights_abtproSlides}
                                            ref={swiperRef}
                                            slidesPerView={4}
                                            pagination={false}
                                            loop={false}
                                            autoHeight={true}
                                            modules={[Pagination, Navigation, Autoplay]}
                                            // autoplay={{ delay: 5000 }}
                                            autoplay={false}
                                            navigation={false}
                                            spaceBetween='23'
                                            
                                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                                            breakpoints={{
                                                300: { slidesPerView: 1, },
                                                480: { slidesPerView: 2, },
                                                830: { slidesPerView: 3, },
                                                1370: { slidesPerView: 4, },
                                            }}
                                            
                                        >
                                            <div className={styles._team_cards}>
                                            <ul className={styles._team_cardsLst}>
                                           
                                            {mergeData && mergeData?.map((team, index) => (
                                                <div>
                                                    <SwiperSlide key={index}>
                                                    
                                                    <li key={index} className={styles.teamSliderLi}>
                                                        <div className={styles._team_card}>
                                                            <div className={styles._team_cardImg}>
                                                                <img src={`${IMAGE_URL}/teams/${team[0].image}`} alt="" loading='lazy' />
                                                            </div>
                                                            <div className={`${styles._team_cardTxt} ${i18n.language === LANG_AR ? 'arabText' : ''} `}>
                                                                {/*  <h3> {team.name}</h3>
                                                    <p>{team.designation}</p> */}
            
                                                                <h3> {i18n.language === LANG_EN ? team[0].name : team[0].nameAr}</h3>
                                                                <p>{i18n.language === LANG_EN ? team[0].designation : team[0].designationAr}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    
                                                    <li key={index} className={styles.teamSliderLi}>
                                                        <div className={styles._team_card}>
                                                            <div className={styles._team_cardImg}>
                                                                <img src={`${IMAGE_URL}/teams/${team[1].image}`} alt="" loading='lazy' />
                                                            </div>
                                                            <div className={`${styles._team_cardTxt} ${i18n.language === LANG_AR ? 'arabText' : ''} `}>
                                                                {/*  <h3> {team.name}</h3>
                                                    <p>{team.designation}</p> */}
            
                                                                <h3> {i18n.language === LANG_EN ? team[1].name : team[1].nameAr}</h3>
                                                                <p>{i18n.language === LANG_EN ? team[1].designation : team[1].designationAr}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </SwiperSlide>
            
                                               
                                                </div>
                                               
            
                                                
                                            ))}
                                            </ul>
                                            </div>
                                        </Swiper>
                                        <div className={styles.customNavigation}>
                                            <button
                                                className={styles.prevButton}
                                                //onClick={() => swiperRef.current?.slidePrev()}
                                                onClick={() => swiperRef.current?.slideTo(Math.max(swiperRef.current.activeIndex - 4, 0))}
                                            >
                                                <img src={leftArrow} alt="" />
                                            </button>
                                            <button
                                                className={styles.nextButton}
                                                //onClick={() => swiperRef.current?.slideNext()}
                                                onClick={() =>
                                                    swiperRef.current?.slideTo(
                                                        Math.min(swiperRef.current.activeIndex + 4, mergeData.length - 1)
                                                    )
                                                }
                                            >
                                                <img src={rgtArrow} alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>

        
        </>
    );
};

export default AboutTeam;
